import styled from 'shared/theme'

export const ButtonContainer = styled.div`
    text-align: center;
    padding: 0.25rem;
`
